<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <v-dialog
            v-model="dialogRemove"
            persistent
            max-width="700px"
            transition="dialog-transition"
            v-if="dialogRemove"
          >
          <v-card class="no__padding">
            <v-card-title>
              <h2>Smazání produktu</h2>
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              Opravu chcete smazat <strong>{{ removeItem.sporici_program }}</strong> z produktů?
            </v-card-text>
            <v-divider class="mt-2 mb-2"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>

              <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
          </v-dialog>
          <div class="custom-scrollbar" v-if="!editMode">
            <v-card color="grey lighten-4" class="pt-3 pb-3 pl-0 pr-0 no__radius" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
              <v-layout row wrap align-center>
                <v-flex xs12 sm6>
                  <v-breadcrumbs divider="/" large disabled="false" class="pa-0">
                    <v-icon slot="divider">chevron_right</v-icon>
                    <v-breadcrumbs-item>
                      <v-btn color="blue" outline @click="gotoall" class="ma-0">Spořící produkty</v-btn>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item :class="{'mb-2 px-2': $vuetify.breakpoint.smAndDown}">
                      {{ item.sporici_program }}
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-flex>

                <v-flex xs12 sm6 class="text-sm-right">
                  <div class="px-2">
                    <v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0" :class="{'v-btn--block': $vuetify.breakpoint.xs}"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
                    <v-btn color="red" @click="removeClick" flat :class="{'v-btn--block mt-2': $vuetify.breakpoint.xs}"><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>
                  </div>
                </v-flex>
              </v-layout>

              <v-card-text>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <h2>{{item.sporici_program}}</h2>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-switch :label="item.aktivni ? 'Aktivní produkt' : 'Neaktivní produkt'" v-model="item.aktivni" color="green" hide-details readonly></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-4">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Měna:</p>
                    <strong v-if="item.mena != null">{{item.mena.nazev}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Informace pro výpočty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Vstupní poplatek placený na začátku (%):</p>
                    <strong v-if="item.vstupni_poplatek != null">{{item.vstupni_poplatek | formatDouble}} %</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Min. cílová částka:</p>
                    <strong v-if="item.min_cilova_castka != null">{{item.min_cilova_castka | formatMoney}} {{item.mena.zkratka}}</strong><span v-else>--</span>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Min. měsíční splátka:</p>
                    <strong v-if="item.min_mesicni_splatka != null">{{item.min_mesicni_splatka | formatMoney}} {{item.mena.zkratka}}</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Kredity</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <p class="grey--text caption mb-1">Kredity z poplatku::</p>
                    <strong v-if="item.poplatek_kredity != null">{{item.poplatek_kredity | formatDouble}} kr.</strong><span v-else>--</span>
                    <strong v-if="item.poplatek_hodnota != null"> na {{item.poplatek_hodnota}} {{item.mena.zkratka}} poplatku</strong><span v-else>--</span>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Cílové produkty:</h3>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :headers="productsHeader"
                  :items="item.cilove_produkty"
                  hide-controls
                  class="mt-2"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">{{props.item.nazev}}</router-link>
                      </td>
                      <td>
                        <div class="mt-3 mb-3" v-for="(i, n) in props.item.nahradni_produkty" :key="'p-'+props.item.id.toString()+'-np-'+i.id.toString()" v-if="props.item.nahradni_produkty.length > 0">
                          <router-link :to="{ path: '/produkty/' + i.id }" target="_blank">{{i.nazev}}</router-link>
                        </div>
                        <div class="mt-3 mb-3" v-else>
                          --
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

              </v-card-text>
            </v-card>

            <!--<v-card-actions class="mt-4">
              <v-spacer></v-spacer>
            </v-card-actions>-->
          </div>

          <div class="custom-scrollbar" v-else>
            <v-card color="grey lighten-4" class="pt-0 pb-3 pr-0 pl-0 pb-1 no__radius" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <h2>{{item.sporici_program}}</h2>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-switch :label="updateItem.aktivni ? 'Aktivní produkt' : 'Neaktivní produkt'" v-model="updateItem.aktivni" color="green" hide-details></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Název spořícího programu" v-model="updateItem.sporici_program" class="mx-2"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <meny v-model="updateItem.mena_id" @changed="(v) => { this.updateItem.mena = v }" disabled></meny>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Informace pro výpočty:</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Vstupní poplatek placený na začátku (%)" v-model="updateItem.vstupni_poplatek" class="mx-2" type="number" suffix="%"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Min. cílová částka" v-model="updateItem.min_cilova_castka" class="mx-2" type="number" :suffix="updateItem.mena.zkratka"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field label="Min. měsíční částka" v-model="updateItem.min_mesicni_splatka" class="mx-2" type="number" :suffix="updateItem.mena.zkratka"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm4>
                    <div class="mx-2">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <span class="caption grey--text text--darken-1">Kredity z poplatku:</span>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap row>
                        <v-flex xs5 d-flex class="mx-1">
                          <v-text-field
                            type="number"
                            v-model="updateItem.poplatek_kredity"
                            suffix="kreditů"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex class="text-xs-center pl-3 pr-3 pt-3 mt-1 shrink">
                          na
                        </v-flex>
                        <v-flex xs5 d-flex class="mx-1">
                          <v-text-field
                            type="number"
                            v-model="updateItem.poplatek_hodnota"
                            :suffix="updateItem.mena != null ? updateItem.mena.zkratka : ''"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex class="pt-3 mt-1 pl-3">
                          poplatku
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <v-flex xs12>
                    <h3>Cílové produkty:</h3>
                  </v-flex>
                </v-layout>
                <v-data-table
                  :headers="editProductsHeader"
                  :items="updateItem.cilove_produkty"
                  hide-controls
                  class="mt-2"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">{{props.item.nazev}}</router-link>
                      </td>
                      <td>
                        <div class="mt-3 mb-3" v-for="(i, n) in props.item.nahradni_produkty">
                          <template>
                            <router-link :to="{ path: '/produkty/' + i.id }" target="_blank">{{i.nazev}}</router-link>
                            <v-icon @click="props.item.nahradni_produkty.splice(props.item.nahradni_produkty.indexOf(i), 1);" color="red" class="ml-2" small>delete</v-icon>
                          </template>
                        </div>
                        <productsearch ref="npSearch" @changed="(e) => { props.item.nahradni_produkty.splice(props.item.nahradni_produkty.length - 1, 0, e); }" label="Vyhledat produkt" class="mt-3 mb-3" clearOnSelect :material="props.item.material" :vaha="props.item.vaha" :typ_produktu="props.item.typ_produktu" loadOnMounted hide-details></productsearch>
                      </td>
                      <td class="text-xs-right">
                        <v-btn color="red" small dark depressed flat class="ma-0 mt-3 mb-3" @click="updateItem.cilove_produkty.splice(updateItem.cilove_produkty.indexOf(props.item), 1)"><v-icon small>delete</v-icon> Smazat cílový produkt</v-btn>
                      </td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <tr>
                      <td colspan="3">
                        <productsearch @changed="productAdded" ref="search" label="Vyhledat produkt" class="mt-3 mb-2" clearOnSelect></productsearch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4">
              <v-btn color="primary" @click="edit" :loading="updating" class="elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
            </v-card-actions>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      // Item variables start
      editMode: false,
      item: {},
      dialogUpdate: false,
      updateItem: {},
      dialogRemove: false,
      removeItem: {},
      updating: false,
      removing: false,
      // Item variables end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      productsHeader: [
        { text: "Produkt", value: "nazev", sortable: false },
        { text: "Náhradní produkty", value: "nahradni_produkty", sortable: false }
      ],
      editProductsHeader: [
        { text: "Produkt", value: "nazev", sortable: false },
        { text: "Náhradní produkty", value: "nahradni_produkty", sortable: false },
        { text: "Akce", value: "produkt", sortable: false, align: 'right' }
      ],
    }
  },
  props: {
    id: String,
    editProduct: Boolean
  },
  mounted: function() {
    this.load();
  },
  methods: {
    gotoall () {
      this.$router.push({ path: "/sporici-produkty" });
    },
    load () {
      window.api.get("sporici-produkty/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
        if (this.$props.editProduct) {
          this.updateItem = window.th.copy(this.item);
          this.editMode = true;
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.editMode = true;
    },
    edit () {
      this.updating = true;
      var item = window.th.copy(this.updateItem);
      item.cilove_produkty = item.cilove_produkty.map((e) => { return {
        id: e.id,
        nahradni: e.nahradni_produkty.map((n) => { return n.id; })
      }; });
      window.api.put("sporici-produkty/" + this.$props.id, item).then((_body) => {
        if (_body.updated) {
          this.item = window.th.copy(this.updateItem);
          this.editMode = false;
        }
        this.updating = false;
        if (this.editProduct)
          this.gotoall();
      }).catch((err) => {
        console.log(err);
        this.updating = false;
      });
    },
    removeClick () {
      this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("sporici-produkty/" + this.$props.id).then((_body) => {
        if (_body.deleted) {
          this.$router.push({ path: "/sporici-produkty" })
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    gotoall () {
      this.$router.push({ path: "/sporici-produkty" });
    },
    productAdded (e) {
      var t = window.th.copy(e);
      t.nahradni_produkty = [];
      this.updateItem.cilove_produkty.splice(this.updateItem.cilove_produkty.length - 1, 0, t);
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Produkty/SporiciProduktDetail.vue